import React from "react";
import { Link } from "react-router-dom";
import InputRow from "./InputRow";
import PropTypes from "prop-types";
import { emailCheck, pwdCheck } from "../constants";
import submit from "../submit.gif";
import logo from "../logo.png";
import "../Main.css";
export default class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      pwd: "",
      error: "",
      errorColor: "red",
      processing: false,
      resetProcessing: false,
      // isActive:false
    };
    //this.handleLogin = this.handleLogin.bind(this)
    //this.resetPassword = this.resetPassword.bind(this)
  }

  // componentDidMount () {

  //   const id = sessionStorage.getItem('id')
  //   const token = sessionStorage.getItem('token')
  //   alert(token)
  //   if (id && token) {
  //     const { history } = this.props
  //     //history.replace('/payment')
  //   }
  // }

  render() {
    var item_value = sessionStorage.getItem("token");

    var myToken = JSON.parse(item_value);

    return (
      <iframe
        className="paymentCSS"
        src={`https://tpayment.eslsca.edu.eg/omni_payment/paymentpage/?mid=${myToken.token}&app=Power Campus Postgraduate Application Form (EGP)`}
      ></iframe>
    );
    //   const { errorColor, email, pwd, error, processing, resetProcessing, isActive } = this.state
    //   fetch(`${process.env.REACT_APP_API_URL}/api/login/GetIsApplicationActive`)
    //     .then(res => res.text())
    //     .then(res => {
    //       if (res) {
    //         this.setState({ isActive: res })
    //       }
    //     })

    //   if (isActive === 'true') {
    //     return (
    //       <div id="mainContainer">
    //         <div id="designBorder"></div>
    //         <img src={logo} className="center main-logo" style={{paddingTop:20}}></img>
    //         <div id="main-page" >
    //           <p
    //             style={{
    //               color: errorColor
    //             }}>
    //             { error}
    //           </p>
    //           <p>
    //           {item_value}
    //           </p>
    //           <div>
    //             <div>
    //               <InputRow
    //                 rowName="Email Address"
    //                 name="email"
    //                 value={ email}
    //                 onChange={(val) => this.setState({ email: val })}
    //                 required="*"

    //               />
    //               <InputRow
    //                 rowName="Password"
    //                 name="password"
    //                 value={ pwd}
    //                 onChange={(val) => this.setState({ pwd: val })}
    //                 required="*"
    //                 onKeyPress={(e) => {
    //                   if (e.key === 'Enter') {
    //                     this.handleLogin()
    //                   }
    //                 }}
    //               />
    //             </div>
    //           </div>
    //           <button className="save" onClick={this.handleLogin} disabled={processing}>
    //             {processing ? <img src={submit} alt="Loading..." style={{ width: 18, height: 18 }}/> : 'Login'}
    //           </button>
    //           <button className="save" onClick={this.resetPassword} disabled={resetProcessing}>
    //             {resetProcessing ? <img src={submit} alt="Loading..." style={{ width: 18, height: 18 }}/> : 'Reset Password'}
    //           </button>
    //           <p>If you don&apos;t have an account, <cite><Link className="links" to="/signup">Create</Link></cite></p>
    //           <p><b>Important:</b> Please note that this password will be used to access your application</p>
    //         </div>

    //       </div>

    //     )
    //   } else {
    //     return (
    //       <div id="mainContainer">
    //         <div id="designBorder"></div>
    //         <img src={logo} className="center main-logo"></img>
    //         <div id="main-page" >
    //           <p
    //             style={{
    //               color: errorColor
    //             }}>
    //             { error}
    //           </p>
    //           <div>

    //           </div>

    //           <p><b>The application form is not available at this time , please check back later</b></p>
    //         </div>

    //       </div>

    //     )
    //   }
  }
}
Payment.propTypes = {
  onLogin: PropTypes.func.isRequired,
  history: PropTypes.object,
};
